import './VideoPreview.scss';

export { default } from './VideoPreview';
